import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpResponse, HttpHeaders, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { LoaderService } from '../services/loader.service';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from '../services/shared.service';

@Injectable({
  providedIn: 'root'
})

export class HttpInterceptorService implements HttpInterceptor {
  private httpCount = 0;
  constructor(
    private _authService: AuthService,
    private _loaderService: LoaderService,
    private _router: Router,
    private _cookieService: CookieService,
    private _sharedService: SharedService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let hideLoader = request.headers.get('hideLoader') === 'true' ? true : false;
    if (!hideLoader) {
      this.httpCount += 1;
      // Starting loader
      this._loaderService.changeLoadingVisibility(true);
    }

    /**
         * * @constant ignore determines whether to ignore the header 'Content-Type' 
         */
    let ignore =
      typeof request.body === 'undefined'
      || request.body === null
      || request.body.toString() === '[object FormData]'
      || request.headers.has('Content-Type');

    /*
     * * Header Content-Type will be passed only if the above statement pass
     */
    if (!ignore) {
      request = request.clone({
        headers: request.headers.set('Content-Type', 'application/json')
      });
    }

    const token = localStorage.getItem("authToken")
    if(token) {
      request = request.clone({
        headers: new HttpHeaders({
          "x-header-authtoken": localStorage.getItem("authToken")
        })
      });
    }

    return next.handle(request).pipe(
      map((res: HttpResponse<any>) => {
        if (res.body) {
          
          if (this.httpCount > 0) {
            this.httpCount -= 1;
          }
          if (this.httpCount === 0) {
            // Stopping loader
            this._loaderService.changeLoadingVisibility(false);
          }

          if (res.body && res.body.tokens) {
            this._authService.setAuthToken(res.body.tokens.authToken);
            localStorage.setItem("authToken", res.body.tokens.authToken);
            delete res.body.tokens;
          }

          return res;
        }
      }),
      catchError((error: any) => {
        this._loaderService.changeLoadingVisibility(false);

        if (this.httpCount > 0) {
          this.httpCount -= 1;
        }

        if (this.httpCount === 0) {
          this._loaderService.changeLoadingVisibility(false);
        }

        if (error.status === 401 || error.name === 'UnauthorizedError' || (error.error && error.error.message === 'invalid token')) {
          localStorage.clear();
          this._cookieService.deleteAll();
          this._router.navigateByUrl('/login');
          if(error.error && error.error.message) {
            this._sharedService.openSnackBar(error.error.message);
          } else {
            this._sharedService.openSnackBar("Unauthorized access. You're denied.");
          }
        } else if (error.status == 402) {
          this._router.navigateByUrl('/subscription')
        } else if (error.status === 500) {
          this._sharedService.openSnackBar("Server side error occurred");
          console.log(error); 
        }
        return throwError(error);
      })
    );
  }

}
